import React from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import TrustSection from '../components/landing/TrustSection';
import ProblemSection from '../components/landing/ProblemSection';
import ServicesSection from '../components/landing/ServicesSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import TrustBadgesSection from '../components/landing/TrustBadgesSection';
import DiagnosticSection from '../components/landing/DiagnosticSection';
import FAQSection from '../components/landing/FAQSection';
import Footer from '../components/landing/Footer';
import WhatsAppButton from '../components/landing/WhatsAppButton';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <TrustSection />
        <ProblemSection />
        <ServicesSection />
        <TestimonialsSection />
        <TrustBadgesSection />
        <DiagnosticSection />
        <FAQSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;
